


















































import { Component, Vue, Prop } from 'nuxt-property-decorator'
import quotes from '~/data/quotes'

@Component({
  name: 'QuoteCarousel',
  components: {}
})
export default class extends Vue {
  quotes = quotes
}
